<script setup lang="ts">
import type { UseShareOptions } from '@vueuse/core'

interface ShareButtonProps {
  title: string
  link: string
  description: string
  coverPhoto: CmsMediaFile
  disabled?: boolean
  width?: number | `${number}` | 'full'
}

const props = defineProps<ShareButtonProps>()

const { t, baseKey } = useI18n('components.molecules.buttons.share-button')

const { share, isSupported: sharingIsSupported } = useShare()

const {
  modalIsOpen: socialModalIsOpen,
  openModal: openSocialModal,
  closeModal: closeSocialModal
} = useModal()

const shareDonationBox = async () => {
  if (!sharingIsSupported.value) {
    return
  }
  const blob = await $fetch<Blob>('/api/donation-box/fetch-image', {
    query: {
      url: props.coverPhoto.url
    }
  })
  const file = new File([blob], props.coverPhoto.filename, {
    type: props.coverPhoto.mimeType
  })

  const shareProps: UseShareOptions = {
    title: props.title,
    text: props.description,
    url: props.link
  }

  if (
    navigator.canShare({
      files: [file]
    })
  ) {
    shareProps.files = [file]
  }

  try {
    await share(shareProps)
  } catch (e) {
    console.error(e)
  }
}
</script>

<template>
  <div>
    <VButton
      class="w-full"
      icon-right="fa-share"
      :disabled
      :width
      @click="() => (sharingIsSupported ? shareDonationBox() : openSocialModal())"
    >
      {{ t('.label') }}
    </VButton>

    <SocialModal
      v-if="!sharingIsSupported && title"
      v-model:open="socialModalIsOpen"
      :modal-title="`${baseKey}.modal.title`"
      :modal-description="`${baseKey}.modal.description`"
      :socials-title="title"
      :socials-link="link"
      @close="closeSocialModal"
    />
  </div>
</template>

<style scoped></style>
